import React, { Component } from "react";
import { ImArrowLeft } from 'react-icons/im';
import { Link } from "react-router-dom";
import '../Styles/ProfessionalHeader.css';


export default class ProfessionalHeader extends Component {
  render() {
    window.onscroll = function() {
      var scroll = window.pageYOffset;
      var header = document.querySelector("header");
    
      if (scroll >= 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    };

    function handleClick() {
      window.scrollTo(0, 0);
    }

    return (
      <header 
        className="professional-header"
      >
        <Link to="/">
          <ImArrowLeft 
            className="back-button" 
            onClick={ handleClick }
            data-aos="fade-right" 
            data-aos-duration="1000"
          />
        </Link>
        <nav
          data-aos="fade-left" 
          data-aos-duration="1000"
        >
          <ul className="links-professional-list">
            <li><a className="professional-link" href="#qualification">Formação</a></li>
            <li><a className="professional-link" href="#exp">Experiência</a></li>
            <li><a className="professional-link" href="#certificate">Certificados</a></li>
          </ul>
        </nav>
      </header>
    )
  }
}